// extracted by mini-css-extract-plugin
module.exports = {"label":"style__label__YXAnw","shaderbox":"style__shaderbox__6r95L","copy":"style__copy__sH-Kf"};